import Css from "./Css.js";
import orderUtil from '../../Utils/orderUtil.js';
import { useEffect,  useCallback } from "react";

function SelectLine(props) {
  const {sldivPosition,editMenuInfo,points,selEditPointsArr,setPoints,copyArr,
    selStartTime,selEndTime,middleWidth,pasteStartTime} = props.data;
  const {hideCopyPaste,setCopyArr} = props.method;
  let width = 0;
  let marginLeft = 0;
  let menuLeft = 0;
  let show = false;
  if(sldivPosition){
    show = sldivPosition.show;
    width = sldivPosition.width;
    marginLeft = sldivPosition.marginLeft;
    menuLeft = marginLeft + width + 20;
  }
  if(editMenuInfo && editMenuInfo.menuLeft > 0){
    menuLeft = editMenuInfo.menuLeft;
  }
  const menuClick = (e, type) => {
    let tmpArr = orderUtil.deepClone(points);
    if(type === "clear"){
      if(selEditPointsArr.length > 1){
        let p1 = selEditPointsArr[0];
        let p2 = selEditPointsArr[selEditPointsArr.length-1];
        let index1 = orderUtil.getPointIndex(tmpArr, p1.t);
        let index2 = orderUtil.getPointIndex(tmpArr, p2.t);
        if(index1 >= 0 && index2 > 1){
          let leftPointsArr = tmpArr.slice(0, index1);
          let rightPointsArr = tmpArr.slice(index2+1);
          let newArr = [];
          if(rightPointsArr.length > 0){ //最后一个点没用被选中
            //在clear掉的线段两端临界的时刻，添加两个level=0的点，让clear的区间强度归零
            let leftEdgePoint = null;
            if(index1 === 0){
              leftEdgePoint = { t:0, v:0 };
            }else{
              leftEdgePoint = leftPointsArr[leftPointsArr.length-1];
            }
            let leftNewPoint = {t:(leftEdgePoint.t+100), v:0};
            let rightEdgePoint = rightPointsArr[0];
            let rightNewPoint = {t:(rightEdgePoint.t-100), v:0};
            if(rightNewPoint.t - 100 >= leftNewPoint.t){
              leftPointsArr.push(leftNewPoint);
              rightPointsArr.unshift(rightNewPoint);
            }
            //补点，防止曲线回绕
            if(rightNewPoint.t - leftNewPoint.t > 1000){
              let initBdArrPoints = { t:leftNewPoint.t + 1000, v:0 };
              let bdArr = [];
              bdArr.push(initBdArrPoints);
              while(rightNewPoint.t - bdArr[bdArr.length - 1].t >= 1000){
                let bdArrLastPoint = bdArr[bdArr.length - 1];
                let newBdPoint = { t:bdArrLastPoint.t + 1000, v:0 };
                bdArr.push(newBdPoint);
              }
              bdArr.push({ t:rightNewPoint.t, v:0 });
              leftPointsArr = leftPointsArr.concat(bdArr);
            }
            newArr = leftPointsArr.concat(rightPointsArr);
          }else{ //选区把最后一个点也选中了
            let leftLastPoint = leftPointsArr[leftPointsArr.length - 1];
            let initBdArrPoints = { t:leftLastPoint.t + 1000, v:0 };
            let bdArr = [];
            bdArr.push(initBdArrPoints);
            let rightLastPoint = selEditPointsArr[selEditPointsArr.length - 1];
            while(rightLastPoint.t - bdArr[bdArr.length-1].t >= 1000){
              let bdArrLastPoint = bdArr[bdArr.length - 1];
              let newBdPoint = { t:bdArrLastPoint.t + 1000, v:0 };
              bdArr.push(newBdPoint);
            }
            bdArr.push({ t:rightLastPoint.t, v:0 });
            newArr = leftPointsArr.concat(bdArr);
          }
          setPoints(newArr);
          hideCopyPaste();
        }
      }
    }else if(type === "copy"){
      setCopyArr(selEditPointsArr);
      hideCopyPaste();
    }else if(type === "paste"){
      if(copyArr.length > 1){
        //黏贴复制的曲线点(计算插入已复制的曲线段)
        if(e && e.target && e.target.parentElement){
          //粘贴逻辑：1、计算粘贴区域
          let menuLeft = parseInt((e.target.parentElement.style.marginLeft + "").replace("px",""));
          let selTime = selEndTime - selStartTime;
          let mdWidth = middleWidth;
          //黏贴位置的起始时间
          let pasteStartTime = orderUtil.formatMs(parseInt((menuLeft/mdWidth)*selTime + selStartTime));
          handlePaste(pasteStartTime);
        }
      }
      hideCopyPaste();
    }else if(type === "cancel"){
      hideCopyPaste();
    }
  }

  const handlePaste = useCallback((pasteStartTime)=>{
    let cp1 = copyArr[0].t;
    let cp2 = copyArr[copyArr.length - 1].t;
    let copyTimeRange = cp2 - cp1;
    let bkPointsArr = orderUtil.deepClone(points);
    let lastPointTime = bkPointsArr[bkPointsArr.length-1].t; //曲线最后一个点的时间
    if(pasteStartTime > lastPointTime){
      pasteStartTime = lastPointTime;
    }
    let pasteEndTime = pasteStartTime + copyTimeRange;  //结束时间
    if(pasteEndTime > selEndTime){
      pasteEndTime = selEndTime;
    }
    //粘贴逻辑：2、计算临界点
    let index1 = 0;
    let index2 = 0;
    for(let a=0; a<bkPointsArr.length; a++){
      let pObj = bkPointsArr[a];
      if(pObj.t >= pasteStartTime && index1 === 0){
        index1 = a;
      }else if(pObj.t >= pasteEndTime && index2 === 0){
        index2 = a;
      }
    }
    //粘贴逻辑：3、在曲线上黏贴曲线，则拼接新曲线(覆盖逻辑)
    if(index1 > 0 && index2 > 0){
      let leftArr = bkPointsArr.slice(0, index1);
      let rightArr = bkPointsArr.slice(index2-1);
      //前后补点，优化粘贴的曲线前后的连接  start
      let timeDiff = pasteStartTime - copyArr[0].t;
      let res2Arr = [];
      let tmpCopyArr = orderUtil.deepClone(copyArr);
      for(let b=0; b<tmpCopyArr.length; b++){
        let cObj = {};
        cObj.t = tmpCopyArr[b].t + timeDiff;
        cObj.v = tmpCopyArr[b].v;
        res2Arr.push(cObj);
      }
      let leftArrLastPoint = leftArr[leftArr.length - 1];
      let rightArrFirstPoint = rightArr[0];
      let res2ArrFirstPoint = res2Arr[0];
      let res2ArrLastPoint = res2Arr[res2Arr.length - 1];
      if(res2ArrFirstPoint.t - leftArrLastPoint.t > 100){
        let addPoint = {t:res2ArrFirstPoint.t - 100, v: leftArrLastPoint.v};
        res2Arr.unshift(addPoint);
      }
      if(rightArrFirstPoint.t - res2ArrLastPoint.t > 100){
        let addPoint = {t:res2ArrLastPoint.t + 100, v:rightArrFirstPoint.v};
        res2Arr.push(addPoint);
      }
      while(res2Arr[res2Arr.length-1] && res2Arr[res2Arr.length-1].t >= rightArr[0].t){
        // console.log("过滤重复点", res2Arr[res2Arr.length-1].t, rightArr[0].t);
        rightArr = rightArr.slice(1);
      }

      //前后补点，优化粘贴的曲线前后的连接  end
      let newArr = leftArr.concat(res2Arr).concat(rightArr);
      setPoints(newArr);
    }else if(index1 === (bkPointsArr.length-1) && index2 === 0){
      //黏贴逻辑：4、在曲线外黏贴曲线，则拼接曲线(追加到最后)
      let res3Arr = [];
      let tmpCopyArr = orderUtil.deepClone(copyArr);
      let copyArrFirstPointTime = copyArr[0].t;
      for(let b=0; b<tmpCopyArr.length; b++){
        let cObj = {};
        cObj.t = tmpCopyArr[b].t - copyArrFirstPointTime + lastPointTime + 100; //平移100ms避免插入重复时间的点
        cObj.v = tmpCopyArr[b].v;
        if(cObj.t <= selEndTime){
          res3Arr.push(cObj);
        }
      }
      let newArr = bkPointsArr.concat(res3Arr);
      setPoints(newArr);
    }          
  },[copyArr,points,selEndTime,setPoints])

  // const [keyCodeArr, setKeyCodeArr] = useState([]); //记录按下的键
  useEffect(()=>{
    // const keyDownEvent = (e)=>{
    //   if (!e.repeat){
    //     let arr = orderUtil.deepClone(keyCodeArr);
    //     arr.push(e.keyCode);
    //     setKeyCodeArr(arr);
    //     if(JSON.stringify(arr) === "[17,67]"){  //ctrl+c
    //       if(selEditPointsArr.length > 1){
    //         setCopyArr(selEditPointsArr);
    //         hideCopyPaste();
    //       }
    //     }else if(JSON.stringify(arr) === "[17,86]"){ //ctrl+v
    //       if(copyArr.length > 1 && pasteStartTime >=0){
    //         handlePaste(pasteStartTime);
    //       }
    //     }
    //   }
    // }
    // const keyUpEvent = (e)=>{
    //   if (!e.repeat){
    //     let index = -1;
    //     let arr = orderUtil.deepClone(keyCodeArr);
    //     for(let i=0; i<arr.length; i++){
    //       if(e.keyCode === arr[i]){
    //         index = arr.indexOf(e.keyCode);
    //         arr.splice(index, 1);
    //       }
    //     }
    //     setKeyCodeArr(arr);
    //   }
    // }
    const copyEvent = (e)=>{
      if(selEditPointsArr.length > 1){
        setCopyArr(selEditPointsArr);
        hideCopyPaste();
      }
    }
    const pasteEvent = (e)=>{
      if(copyArr.length > 1 && pasteStartTime >=0){
        handlePaste(pasteStartTime);
      }
    }
    // window.addEventListener('keydown', keyDownEvent, false);
    // window.addEventListener('keyup', keyUpEvent, false);
    window.addEventListener('copy', copyEvent, false);
    window.addEventListener('paste', pasteEvent, false);
    return function(){
      // window.removeEventListener('keydown', keyDownEvent, false);
      // window.removeEventListener('keyup', keyUpEvent, false);
      window.removeEventListener('copy', copyEvent, false);
      window.removeEventListener('paste', pasteEvent, false);
    }
  },[selEditPointsArr,hideCopyPaste,copyArr,setCopyArr,pasteStartTime,handlePaste]);

  return (
    <>
      {
        show && width > 0 ? 
        <div style={ Css.SelectLine(width,marginLeft) }></div> : ""
      }
      {
        editMenuInfo && editMenuInfo.show ?
        <div style={ Css.Menu(menuLeft) }>
          {
            (editMenuInfo.btn+"").indexOf("clear") >= 0 ?
            <div style={ Css.menuItem } onClick={ (e)=>{ menuClick(e, 'clear') } }>Clear</div> : ""
          }
          {
            (editMenuInfo.btn+"").indexOf("copy") >= 0 ?
            <div style={ Css.menuItem } onClick={ (e)=>{ menuClick(e, 'copy') } }>Copy</div> : ""
          }
          {
            (editMenuInfo.btn+"").indexOf("paste") >= 0 ?
            <div style={ Css.menuItem } onClick={ (e)=>{ menuClick(e, 'paste') } }>Paste</div> : ""
          }
          {
            (editMenuInfo.btn+"").indexOf("cancel") >= 0 ?
            <div style={ Css.menuItem2 } onClick={ (e)=>{ menuClick(e, 'cancel') } }>Cancel</div> : ""
          }
        </div> : ""
      }
    </>
  );
} 

export default SelectLine;
